// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --primary-color: #1565c0;
  --secondary-color: #0d47a1;
  --accent-color: #42a5f5;
  --light-bg: #f0f4f8;
  --dark-text: #333;
  --light-text: #fff;
  --border-radius: 12px;
  --box-shadow: 0 8px 30px rgba(0,0,0,0.2);
}

.InitialQuestionnaire_overlay__CRuHU {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: transparent;
  pointer-events: none;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 2000;
}

.InitialQuestionnaire_container__cB0Jw {
  width: 100%;
  max-width: 720px;
  max-height: 90vh;
  margin: 20px;
  background: #fff;
  border-radius: var(--border-radius);
  box-shadow: var(--box-shadow);
  display: flex;
  flex-direction: column;
  overflow: hidden;
  pointer-events: auto;
}

.InitialQuestionnaire_header__FtwcS {
  padding: 16px 20px;
  background: var(--primary-color);
  color: var(--light-text);
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.InitialQuestionnaire_title__XoNea {
  margin: 0;
  font-size: 18px;
  font-weight: 600;
}

.InitialQuestionnaire_closeButton__3YKvp {
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  width: 32px;
  height: 32px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.8;
  transition: opacity 0.2s;
}
.InitialQuestionnaire_closeButton__3YKvp:hover {
  opacity: 1;
}

.InitialQuestionnaire_progressBar__mogYO {
  position: relative;
  height: 8px;
  background: #e3f2fd;
}

.InitialQuestionnaire_progressFill__xOW2X {
  height: 100%;
  background: linear-gradient(90deg, var(--accent-color), var(--primary-color));
  transition: width 0.3s ease;
}

.InitialQuestionnaire_progressText__18gD9 {
  position: absolute;
  top: 12px;
  right: 20px;
  font-size: 12px;
  color: #666;
}

.InitialQuestionnaire_content__KAbyG {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
  background: var(--light-bg);
}

.InitialQuestionnaire_questionContainer__kqarj {
  background: #fff;
  border-radius: var(--border-radius);
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
  border-left: 4px solid var(--accent-color);
}

.InitialQuestionnaire_questionTitle__VqsIo {
  margin: 0 0 20px;
  color: var(--primary-color);
  font-size: 16px;
  font-weight: 600;
  line-height: 1.4;
}

.InitialQuestionnaire_options__mQwX\\+ {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.InitialQuestionnaire_deviceNameInput__k16K9 {
  width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 10px;
  padding: 12px 14px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.2s, box-shadow 0.2s;
}
.InitialQuestionnaire_deviceNameInput__k16K9:focus {
  border-color: var(--primary-color);
  box-shadow: 0 0 0 3px rgba(21, 101, 192, 0.12);
}

.InitialQuestionnaire_option__B5Fhe {
  display: flex;
  gap: 12px;
  padding: 14px;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  background: #f9f9f9;
  cursor: pointer;
  transition: all 0.2s;
  position: relative;
}
.InitialQuestionnaire_option__B5Fhe:hover {
  background: #f0f0f0;
  border-color: #d0d0d0;
  transform: translateY(-1px);
}
.InitialQuestionnaire_option__B5Fhe.InitialQuestionnaire_selected__F-doy {
  background: var(--primary-color);
  border-color: var(--primary-color);
  color: white;
}
.InitialQuestionnaire_option__B5Fhe.InitialQuestionnaire_selected__F-doy .InitialQuestionnaire_optionLetter__sp-sX {
  background: rgba(255, 255, 255, 0.2);
  color: white;
  border-color: rgba(255, 255, 255, 0.3);
}
.InitialQuestionnaire_option__B5Fhe.InitialQuestionnaire_readOnlyOption__Qftg6 {
  cursor: default;
  opacity: 0.8;
}
.InitialQuestionnaire_option__B5Fhe.InitialQuestionnaire_readOnlyOption__Qftg6:not(.InitialQuestionnaire_selected__F-doy) {
  background: #f5f5f5;
  border-color: #e0e0e0;
}
.InitialQuestionnaire_option__B5Fhe.InitialQuestionnaire_readOnlyOption__Qftg6:hover {
  transform: none;
  box-shadow: none;
}

.InitialQuestionnaire_optionLetter__sp-sX {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  color: var(--primary-color);
  background: rgba(21, 101, 192, 0.1);
  border: 1px solid rgba(21, 101, 192, 0.2);
  flex-shrink: 0;
}

.InitialQuestionnaire_optionText__R3EBY {
  flex: 1 1;
  font-size: 14px;
  line-height: 1.5;
}

.InitialQuestionnaire_footer__YOnrW {
  padding: 16px 20px;
  background: #fff;
  border-top: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  gap: 12px;
}

.InitialQuestionnaire_navButton__vge4x {
  flex: 1 1;
  padding: 12px 16px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  border: 1px solid var(--primary-color);
}

.InitialQuestionnaire_prevButton__gANq1 {
  background: transparent;
  color: var(--primary-color);
}
.InitialQuestionnaire_prevButton__gANq1:hover:not(:disabled) {
  background: rgba(21, 101, 192, 0.1);
}

.InitialQuestionnaire_nextButton__lwtMz {
  background: var(--primary-color);
  color: white;
}
.InitialQuestionnaire_nextButton__lwtMz:hover:not(:disabled) {
  background: var(--secondary-color);
}

.InitialQuestionnaire_submitButton__Ydsy5 {
  flex: 1 1;
  padding: 12px 16px;
  background: #4caf50;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s;
}
.InitialQuestionnaire_submitButton__Ydsy5:hover:not(:disabled) {
  background: #388e3c;
}

.InitialQuestionnaire_disabled__0H5Dj {
  opacity: 0.6;
  cursor: not-allowed;
}

.InitialQuestionnaire_overviewHeader__CBb-O {
  padding: 16px 20px;
  background: #ffffff;
  border-bottom: 1px solid #eee;
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 12px;
}

.InitialQuestionnaire_overviewTitle__L8XzR {
  font-size: 14px;
  font-weight: 700;
  color: var(--primary-color);
}

.InitialQuestionnaire_overviewActions__fmqF1 {
  display: flex;
  gap: 10px;
  align-items: center;
}

.InitialQuestionnaire_overviewBackButton__SZyzS {
  background: transparent;
  color: var(--primary-color);
  border: 1px solid var(--primary-color);
  border-radius: 8px;
  padding: 10px 12px;
  font-size: 13px;
  cursor: pointer;
  transition: all 0.2s;
}
.InitialQuestionnaire_overviewBackButton__SZyzS:hover {
  background: rgba(21, 101, 192, 0.1);
}

.InitialQuestionnaire_overviewContent__LvpzM {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
  background: var(--light-bg);
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.InitialQuestionnaire_overviewItem__z4RF\\+ {
  background: #fff;
  border-radius: 12px;
  border: 1px solid #e5e7eb;
  padding: 14px;
  cursor: pointer;
  transition: all 0.2s;
}
.InitialQuestionnaire_overviewItem__z4RF\\+:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
  border-color: rgba(21, 101, 192, 0.35);
}

.InitialQuestionnaire_overviewQuestionRow__gbRgn {
  display: flex;
  align-items: flex-start;
  gap: 10px;
}

.InitialQuestionnaire_overviewQId__NHnXF {
  flex: 0 0 auto;
  font-weight: 800;
  color: var(--primary-color);
  background: rgba(21, 101, 192, 0.08);
  border: 1px solid rgba(21, 101, 192, 0.18);
  border-radius: 10px;
  padding: 6px 10px;
  line-height: 1;
}

.InitialQuestionnaire_overviewQTitle__foBYG {
  flex: 1 1;
  font-size: 14px;
  font-weight: 700;
  color: #222;
  line-height: 1.45;
}

.InitialQuestionnaire_overviewAnswerTag__EeqQ- {
  flex: 0 0 auto;
  font-size: 12px;
  font-weight: 800;
  color: #16a34a;
  background: rgba(22, 163, 74, 0.12);
  border: 1px solid rgba(22, 163, 74, 0.22);
  border-radius: 999px;
  padding: 4px 10px;
  line-height: 1;
}

.InitialQuestionnaire_overviewAnswerText__t28Wb {
  margin-top: 10px;
  font-size: 13px;
  color: #334155;
  line-height: 1.55;
}

@media (max-width: 768px) {
  .InitialQuestionnaire_container__cB0Jw {
    margin: 0;
    max-height: 100vh;
    border-radius: 0;
  }
  .InitialQuestionnaire_content__KAbyG {
    padding: 16px;
  }
  .InitialQuestionnaire_questionContainer__kqarj {
    padding: 16px;
  }
  .InitialQuestionnaire_footer__YOnrW {
    flex-direction: column;
  }
  .InitialQuestionnaire_navButton__vge4x,
  .InitialQuestionnaire_submitButton__Ydsy5 {
    width: 100%;
  }
  .InitialQuestionnaire_overviewHeader__CBb-O {
    flex-direction: column;
    align-items: stretch;
  }
  .InitialQuestionnaire_overviewActions__fmqF1 {
    justify-content: flex-end;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/InitialQuestionnaire/index.module.scss"],"names":[],"mappings":"AAAA;EACE,wBAAA;EACA,0BAAA;EACA,uBAAA;EACA,mBAAA;EACA,iBAAA;EACA,kBAAA;EACA,qBAAA;EACA,wCAAA;AACF;;AAEA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EAGA,uBAAA;EACA,oBAAA;EAEA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;AAFF;;AAKA;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;EACA,gBAAA;EACA,mCAAA;EACA,6BAAA;EACA,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,oBAAA;AAFF;;AAKA;EACE,kBAAA;EACA,gCAAA;EACA,wBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;AAFF;;AAKA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AAFF;;AAKA;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,wBAAA;AAFF;AAIE;EACE,UAAA;AAFJ;;AAMA;EACE,kBAAA;EACA,WAAA;EACA,mBAAA;AAHF;;AAMA;EACE,YAAA;EACA,6EAAA;EACA,2BAAA;AAHF;;AAMA;EACE,kBAAA;EACA,SAAA;EACA,WAAA;EACA,eAAA;EACA,WAAA;AAHF;;AAMA;EACE,SAAA;EACA,gBAAA;EACA,aAAA;EACA,2BAAA;AAHF;;AAMA;EACE,gBAAA;EACA,mCAAA;EACA,aAAA;EACA,yCAAA;EACA,0CAAA;AAHF;;AAMA;EACE,gBAAA;EACA,2BAAA;EACA,eAAA;EACA,gBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAHF;;AAMA;EACE,WAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,aAAA;EACA,8CAAA;AAHF;AAKE;EACE,kCAAA;EACA,8CAAA;AAHJ;;AAOA;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,yBAAA;EACA,kBAAA;EACA,mBAAA;EACA,eAAA;EACA,oBAAA;EACA,kBAAA;AAJF;AAME;EACE,mBAAA;EACA,qBAAA;EACA,2BAAA;AAJJ;AAOE;EACE,gCAAA;EACA,kCAAA;EACA,YAAA;AALJ;AAOI;EACE,oCAAA;EACA,YAAA;EACA,sCAAA;AALN;AASE;EACE,eAAA;EACA,YAAA;AAPJ;AASI;EACE,mBAAA;EACA,qBAAA;AAPN;AAUI;EACE,eAAA;EACA,gBAAA;AARN;;AAaA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,gBAAA;EACA,2BAAA;EACA,mCAAA;EACA,yCAAA;EACA,cAAA;AAVF;;AAaA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;AAVF;;AAaA;EACE,kBAAA;EACA,gBAAA;EACA,0BAAA;EACA,aAAA;EACA,8BAAA;EACA,SAAA;AAVF;;AAaA;EACE,SAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;EACA,sCAAA;AAVF;;AAaA;EACE,uBAAA;EACA,2BAAA;AAVF;AAYE;EACE,mCAAA;AAVJ;;AAcA;EACE,gCAAA;EACA,YAAA;AAXF;AAaE;EACE,kCAAA;AAXJ;;AAeA;EACE,SAAA;EACA,kBAAA;EACA,mBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,oBAAA;AAZF;AAcE;EACE,mBAAA;AAZJ;;AAgBA;EACE,YAAA;EACA,mBAAA;AAbF;;AAgBA;EACE,kBAAA;EACA,mBAAA;EACA,6BAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,SAAA;AAbF;;AAgBA;EACE,eAAA;EACA,gBAAA;EACA,2BAAA;AAbF;;AAgBA;EACE,aAAA;EACA,SAAA;EACA,mBAAA;AAbF;;AAgBA;EACE,uBAAA;EACA,2BAAA;EACA,sCAAA;EACA,kBAAA;EACA,kBAAA;EACA,eAAA;EACA,eAAA;EACA,oBAAA;AAbF;AAeE;EACE,mCAAA;AAbJ;;AAiBA;EACE,SAAA;EACA,gBAAA;EACA,aAAA;EACA,2BAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;AAdF;;AAiBA;EACE,gBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,eAAA;EACA,oBAAA;AAdF;AAgBE;EACE,2BAAA;EACA,0CAAA;EACA,sCAAA;AAdJ;;AAkBA;EACE,aAAA;EACA,uBAAA;EACA,SAAA;AAfF;;AAkBA;EACE,cAAA;EACA,gBAAA;EACA,2BAAA;EACA,oCAAA;EACA,0CAAA;EACA,mBAAA;EACA,iBAAA;EACA,cAAA;AAfF;;AAkBA;EACE,SAAA;EACA,eAAA;EACA,gBAAA;EACA,WAAA;EACA,iBAAA;AAfF;;AAkBA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,mCAAA;EACA,yCAAA;EACA,oBAAA;EACA,iBAAA;EACA,cAAA;AAfF;;AAkBA;EACE,gBAAA;EACA,eAAA;EACA,cAAA;EACA,iBAAA;AAfF;;AAkBA;EACE;IACE,SAAA;IACA,iBAAA;IACA,gBAAA;EAfF;EAkBA;IACE,aAAA;EAhBF;EAmBA;IACE,aAAA;EAjBF;EAoBA;IACE,sBAAA;EAlBF;EAqBA;;IAEE,WAAA;EAnBF;EAsBA;IACE,sBAAA;IACA,oBAAA;EApBF;EAuBA;IACE,yBAAA;EArBF;AACF","sourcesContent":[":root {\n  --primary-color: #1565c0;\n  --secondary-color: #0d47a1;\n  --accent-color: #42a5f5;\n  --light-bg: #f0f4f8;\n  --dark-text: #333;\n  --light-text: #fff;\n  --border-radius: 12px;\n  --box-shadow: 0 8px 30px rgba(0,0,0,0.2);\n}\n\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n\n  // 与 ChatDialog 一致：不使用暗色遮罩，同时允许操作穿透到背后页面\n  background: transparent;\n  pointer-events: none;\n\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 2000;\n}\n\n.container {\n  width: 100%;\n  max-width: 720px;\n  max-height: 90vh;\n  margin: 20px;\n  background: #fff;\n  border-radius: var(--border-radius);\n  box-shadow: var(--box-shadow);\n  display: flex;\n  flex-direction: column;\n  overflow: hidden;\n  pointer-events: auto;\n}\n\n.header {\n  padding: 16px 20px;\n  background: var(--primary-color);\n  color: var(--light-text);\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.title {\n  margin: 0;\n  font-size: 18px;\n  font-weight: 600;\n}\n\n.closeButton {\n  background: none;\n  border: none;\n  color: white;\n  font-size: 24px;\n  cursor: pointer;\n  padding: 0;\n  width: 32px;\n  height: 32px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  opacity: 0.8;\n  transition: opacity 0.2s;\n\n  &:hover {\n    opacity: 1;\n  }\n}\n\n.progressBar {\n  position: relative;\n  height: 8px;\n  background: #e3f2fd;\n}\n\n.progressFill {\n  height: 100%;\n  background: linear-gradient(90deg, var(--accent-color), var(--primary-color));\n  transition: width 0.3s ease;\n}\n\n.progressText {\n  position: absolute;\n  top: 12px;\n  right: 20px;\n  font-size: 12px;\n  color: #666;\n}\n\n.content {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n  background: var(--light-bg);\n}\n\n.questionContainer {\n  background: #fff;\n  border-radius: var(--border-radius);\n  padding: 20px;\n  box-shadow: 0 2px 8px rgba(0,0,0,0.05);\n  border-left: 4px solid var(--accent-color);\n}\n\n.questionTitle {\n  margin: 0 0 20px;\n  color: var(--primary-color);\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 1.4;\n}\n\n.options {\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.deviceNameInput {\n  width: 100%;\n  border: 1px solid #e0e0e0;\n  border-radius: 10px;\n  padding: 12px 14px;\n  font-size: 14px;\n  outline: none;\n  transition: border-color 0.2s, box-shadow 0.2s;\n\n  &:focus {\n    border-color: var(--primary-color);\n    box-shadow: 0 0 0 3px rgba(21, 101, 192, 0.12);\n  }\n}\n\n.option {\n  display: flex;\n  gap: 12px;\n  padding: 14px;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  background: #f9f9f9;\n  cursor: pointer;\n  transition: all 0.2s;\n  position: relative;\n\n  &:hover {\n    background: #f0f0f0;\n    border-color: #d0d0d0;\n    transform: translateY(-1px);\n  }\n\n  &.selected {\n    background: var(--primary-color);\n    border-color: var(--primary-color);\n    color: white;\n\n    .optionLetter {\n      background: rgba(255, 255, 255, 0.2);\n      color: white;\n      border-color: rgba(255, 255, 255, 0.3);\n    }\n  }\n\n  &.readOnlyOption {\n    cursor: default;\n    opacity: 0.8;\n    \n    &:not(.selected) {\n      background: #f5f5f5;\n      border-color: #e0e0e0;\n    }\n    \n    &:hover {\n      transform: none;\n      box-shadow: none;\n    }\n  }\n}\n\n.optionLetter {\n  width: 32px;\n  height: 32px;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  color: var(--primary-color);\n  background: rgba(21, 101, 192, 0.1);\n  border: 1px solid rgba(21, 101, 192, 0.2);\n  flex-shrink: 0;\n}\n\n.optionText {\n  flex: 1;\n  font-size: 14px;\n  line-height: 1.5;\n}\n\n.footer {\n  padding: 16px 20px;\n  background: #fff;\n  border-top: 1px solid #eee;\n  display: flex;\n  justify-content: space-between;\n  gap: 12px;\n}\n\n.navButton {\n  flex: 1;\n  padding: 12px 16px;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  border: 1px solid var(--primary-color);\n}\n\n.prevButton {\n  background: transparent;\n  color: var(--primary-color);\n\n  &:hover:not(:disabled) {\n    background: rgba(21, 101, 192, 0.1);\n  }\n}\n\n.nextButton {\n  background: var(--primary-color);\n  color: white;\n\n  &:hover:not(:disabled) {\n    background: var(--secondary-color);\n  }\n}\n\n.submitButton {\n  flex: 1;\n  padding: 12px 16px;\n  background: #4caf50;\n  color: white;\n  border: none;\n  border-radius: 8px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  transition: all 0.2s;\n\n  &:hover:not(:disabled) {\n    background: #388e3c;\n  }\n}\n\n.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.overviewHeader {\n  padding: 16px 20px;\n  background: #ffffff;\n  border-bottom: 1px solid #eee;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: 12px;\n}\n\n.overviewTitle {\n  font-size: 14px;\n  font-weight: 700;\n  color: var(--primary-color);\n}\n\n.overviewActions {\n  display: flex;\n  gap: 10px;\n  align-items: center;\n}\n\n.overviewBackButton {\n  background: transparent;\n  color: var(--primary-color);\n  border: 1px solid var(--primary-color);\n  border-radius: 8px;\n  padding: 10px 12px;\n  font-size: 13px;\n  cursor: pointer;\n  transition: all 0.2s;\n\n  &:hover {\n    background: rgba(21, 101, 192, 0.1);\n  }\n}\n\n.overviewContent {\n  flex: 1;\n  overflow-y: auto;\n  padding: 20px;\n  background: var(--light-bg);\n  display: flex;\n  flex-direction: column;\n  gap: 12px;\n}\n\n.overviewItem {\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid #e5e7eb;\n  padding: 14px;\n  cursor: pointer;\n  transition: all 0.2s;\n\n  &:hover {\n    transform: translateY(-1px);\n    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);\n    border-color: rgba(21, 101, 192, 0.35);\n  }\n}\n\n.overviewQuestionRow {\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n}\n\n.overviewQId {\n  flex: 0 0 auto;\n  font-weight: 800;\n  color: var(--primary-color);\n  background: rgba(21, 101, 192, 0.08);\n  border: 1px solid rgba(21, 101, 192, 0.18);\n  border-radius: 10px;\n  padding: 6px 10px;\n  line-height: 1;\n}\n\n.overviewQTitle {\n  flex: 1;\n  font-size: 14px;\n  font-weight: 700;\n  color: #222;\n  line-height: 1.45;\n}\n\n.overviewAnswerTag {\n  flex: 0 0 auto;\n  font-size: 12px;\n  font-weight: 800;\n  color: #16a34a;\n  background: rgba(22, 163, 74, 0.12);\n  border: 1px solid rgba(22, 163, 74, 0.22);\n  border-radius: 999px;\n  padding: 4px 10px;\n  line-height: 1;\n}\n\n.overviewAnswerText {\n  margin-top: 10px;\n  font-size: 13px;\n  color: #334155;\n  line-height: 1.55;\n}\n\n@media (max-width: 768px) {\n  .container {\n    margin: 0;\n    max-height: 100vh;\n    border-radius: 0;\n  }\n\n  .content {\n    padding: 16px;\n  }\n\n  .questionContainer {\n    padding: 16px;\n  }\n\n  .footer {\n    flex-direction: column;\n  }\n\n  .navButton,\n  .submitButton {\n    width: 100%;\n  }\n\n  .overviewHeader {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .overviewActions {\n    justify-content: flex-end;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"overlay": `InitialQuestionnaire_overlay__CRuHU`,
	"container": `InitialQuestionnaire_container__cB0Jw`,
	"header": `InitialQuestionnaire_header__FtwcS`,
	"title": `InitialQuestionnaire_title__XoNea`,
	"closeButton": `InitialQuestionnaire_closeButton__3YKvp`,
	"progressBar": `InitialQuestionnaire_progressBar__mogYO`,
	"progressFill": `InitialQuestionnaire_progressFill__xOW2X`,
	"progressText": `InitialQuestionnaire_progressText__18gD9`,
	"content": `InitialQuestionnaire_content__KAbyG`,
	"questionContainer": `InitialQuestionnaire_questionContainer__kqarj`,
	"questionTitle": `InitialQuestionnaire_questionTitle__VqsIo`,
	"options": `InitialQuestionnaire_options__mQwX+`,
	"deviceNameInput": `InitialQuestionnaire_deviceNameInput__k16K9`,
	"option": `InitialQuestionnaire_option__B5Fhe`,
	"selected": `InitialQuestionnaire_selected__F-doy`,
	"optionLetter": `InitialQuestionnaire_optionLetter__sp-sX`,
	"readOnlyOption": `InitialQuestionnaire_readOnlyOption__Qftg6`,
	"optionText": `InitialQuestionnaire_optionText__R3EBY`,
	"footer": `InitialQuestionnaire_footer__YOnrW`,
	"navButton": `InitialQuestionnaire_navButton__vge4x`,
	"prevButton": `InitialQuestionnaire_prevButton__gANq1`,
	"nextButton": `InitialQuestionnaire_nextButton__lwtMz`,
	"submitButton": `InitialQuestionnaire_submitButton__Ydsy5`,
	"disabled": `InitialQuestionnaire_disabled__0H5Dj`,
	"overviewHeader": `InitialQuestionnaire_overviewHeader__CBb-O`,
	"overviewTitle": `InitialQuestionnaire_overviewTitle__L8XzR`,
	"overviewActions": `InitialQuestionnaire_overviewActions__fmqF1`,
	"overviewBackButton": `InitialQuestionnaire_overviewBackButton__SZyzS`,
	"overviewContent": `InitialQuestionnaire_overviewContent__LvpzM`,
	"overviewItem": `InitialQuestionnaire_overviewItem__z4RF+`,
	"overviewQuestionRow": `InitialQuestionnaire_overviewQuestionRow__gbRgn`,
	"overviewQId": `InitialQuestionnaire_overviewQId__NHnXF`,
	"overviewQTitle": `InitialQuestionnaire_overviewQTitle__foBYG`,
	"overviewAnswerTag": `InitialQuestionnaire_overviewAnswerTag__EeqQ-`,
	"overviewAnswerText": `InitialQuestionnaire_overviewAnswerText__t28Wb`
};
export default ___CSS_LOADER_EXPORT___;
